import React from 'react';
import { Box, Typography, Link, Stack } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { config } from '../config';

type FooterProps = {
  sx?: SxProps<Theme>;
};

export default function Footer({ sx }: FooterProps) {
  const year = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: theme.zIndex.appBar + 1,
        borderTop: '1px solid',
        borderColor: 'divider',
        py: 1.5,
        px: 2,
        bgcolor: theme.palette.background.paper,
        color: 'text.secondary',
        ...((typeof sx === 'function' ? (sx as any)(theme) : sx) || {}),
      })}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{ textAlign: 'center' }}
        >
          <Typography variant="body2">
            © {year} {config.companyName}. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
            {config.privacyUrl && (
              <Link href={config.privacyUrl} target="_blank" rel="noopener" underline="hover" variant="body2">
                Privacy
              </Link>
            )}
            {config.termsUrl && (
              <Link href={config.termsUrl} target="_blank" rel="noopener" underline="hover" variant="body2">
                Terms
              </Link>
            )}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
